export default (function (siteVars) {
    return {
        backgroundColor: siteVars.gray10,
        fontColor: siteVars.gray02,
        inputFocusBorderColor: siteVars.brand,
        iconColor: siteVars.gray02,
    };
});
